<template>
  <div>
    <div class="row">
      <div class="col mb-4">
        <info-card
          :title="'Vendas do dia'"
          icon="fa-shopping-cart"
          variant="success"
          :value="todayOrderTotal.sum_net_total"
        />
      </div>
      <div class="col mb-4">
        <info-card
          :title="'Vendas do mês'"
          icon="fa-shopping-cart"
          variant="primary"
          :value="monthOrderTotal.sum_net_total"
        />
      </div>
      <div class="col mb-4">
        <info-card
          :title="'Lucro do mês'"
          icon="fa-solid fa-dollar-sign"
          variant="success"
          :value="monthProfit.sum_profit"
        />
      </div>
      <div class="col mb-4">
        <info-card
          :title="'Total contas a receber'"
          icon="fa-file-invoice-dollar"
          variant="success"
          :value="openBillReceivebleTotal.sum_due_value"
        />
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 mb-4">
        <div class="card">
          <div class="card-body">
            <span class="text-muted">Vendas por mês</span>
            <hr />
            <order-historic-chart :data="orderTotalByMonth" />
            <!-- <app-bar-chart :series="accountTransactionSeries" :categories="accountTransactionLabels"/> -->
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <!-- <div class="card">
          <div class="card-body">
            <span class="text-muted">Saldos dos caixas e contas</span>
            <hr />
            <div class="row mb-4" v-for="(account, accountIndex) in accounts" :key="accountIndex">
              <div class="col-6">
                <template v-if="account.type == 'c'">
                  <span class="fa-stack fa-1x">
                    <i class="fas fa-circle fa-stack-2x text-success"></i>
                    <i class="fas fa-cash-register fa-stack-1x fa-inverse text-white"></i>
                  </span>
                </template>
                <template v-else>
                  <span class="fa-stack fa-1x">
                    <i class="fas fa-circle fa-stack-2x text-primary"></i>
                    <i class="fas fa-university fa-stack-1x fa-inverse text-white"></i>
                  </span>
                </template>
                <span>{{ account.description }}</span>
              </div>
              <div class="col-6 text-right">{{ getAccountBalance(account.id) | decimal }}</div>
            </div>
          </div>
        </div> -->


        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <span class="text-muted">Ranking de Vendedores</span>
                <hr>
                <div class="row">

                <div class="col-md-4">
                  <date-input v-model="searchForm.start_date" alias="Data Inicial" />
                </div>
                <div class="col-md-4">
                  <date-input v-model="searchForm.end_date" alias="Data Final" />
                </div>
                <div class="col-md-4 d-flex align-items-end">
                  <div class="form-group">
                    <button type="button" class="btn btn-sm btn-primary" @click="select()">
                      <i class="fas fa-search" /> Pesquisar
                    </button>
                  </div>
                </div>
                </div>

                <hr />
                <div class="row mb-4" v-for="(row, index) in orderBySalesman" :key="index">
                  <div class="col-6">
                    <template v-if="row.name != null">
                      <avatar
                        inline
                        color="#fff"
                        :size="30"
                        :username="row.name"
                        :initials="row.name.slice(0, 1)"
                      ></avatar>
                      <span style="margin-left:10px">{{ row.name }}</span>
                    </template>
                    <template v-else>
                      <avatar
                        inline
                        color="#fff"
                        :size="30"
                        :username="'Consumidor Final'"
                        :initials="'CF'"
                      ></avatar>
                      <span style="margin-left:10px">Vendedor Não Indentificado</span>
                    </template>
                  </div>
                  <div class="col-6 text-right">{{ row.sum_net_total | decimal}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-4 mt-3">
        <span class="text-muted">Em breve, mais indicadores...</span>
      </div>
    </div>
    <br />

    <error-handler :error="error" />
  </div>
</template>

<script>
import TablePaginator from "./../sections/TablePaginator.vue";
import InfoCard from "./../sections/dashboard/InfoCard.vue";
import AppBarChart from "./../ui/AppBarChart.vue";
import OrderHistoricChart from "./../charts/OrderHistoricChart.vue";
import Filter from "./../../mixins/Filters";
import Avatar from "vue-avatar";

export default {
  components: {
    InfoCard,
    AppBarChart,
    OrderHistoricChart,
    Avatar
  },

  data: function() {
    return {

      searchForm : {
        start_date : null,
        end_date : null
      },
      series: [
        {
          data: []
        },
        {
          data: []
        }
      ],

      //labels : [2001, 2002, 2003, 2004, 2005, 2006, 2007],

      todayOrderTotal: {},

      monthOrderTotal: {},

      monthProfit: {
        sum_profit:{}
      },

      accounts: {},

      accountsBalance: {},

      openBillReceivebleTotal: {},

      orderBySalesman: {},
      // accountTransactionsOut : [],
      // accountTransactionsIn : [],

      error: null,

      orderTotalByMonth: {}
    };
  },

  created() {
    axios
      .post("api/dashboard/select", this.searchForm)
      .then(response => {
        this.todayOrderTotal = response.data.todayOrderTotal;
        this.monthOrderTotal = response.data.monthOrderTotal;
        this.accounts = response.data.accounts;
        this.monthProfit = response.data.monthProfit;
        this.accountsBalance = response.data.accountsBalance;
        this.openBillReceivebleTotal = response.data.openBillReceivebleTotal;
        this.orderBySalesman = response.data.orderBySalesman;
        // this.accountTransactionsIn   = response.data.accountTransactionsIn;
        this.orderTotalByMonth = response.data.orderTotalByMonth;

        this.$store.commit("pageHasLoaded");
      })
      .catch(error => {
        this.error = error;
        this.$store.commit("pageHasLoadedWithError", { error: error });
      });
  },

  computed: {
    accountTransactionSeries() {
      let series = [];
      let labels = [];

      series[0] = {};
      series[0].name = "Entradas";
      series[0].data = this.accountTransactionsIn.map(elem => elem.sum_value);

      series[1] = {};
      series[1].name = "Saidas";
      series[1].data = this.accountTransactionsOut.map(
        elem => elem.sum_value * -1
      );

      return series;
    },

    accountTransactionLabels() {
      let labelsIn = this.accountTransactionsOut.map(elem => elem.paid_at);
      return labelsIn;
    }
  },

  methods: {
    getAccountBalance(id) {
      if (this.accountsBalance[id] == null) {
        return 0;
      }
      return this.accountsBalance[id].balance;
    },

    select() {
      this.$store.commit("showLoading");
      axios
      .post("api/dashboard/select", this.searchForm)
      .then(response => {
        this.todayOrderTotal = response.data.todayOrderTotal;
        this.monthOrderTotal = response.data.monthOrderTotal;
        this.monthProfit = response.data.monthProfit;
        this.accounts = response.data.accounts;
        this.accountsBalance = response.data.accountsBalance;
        this.openBillReceivebleTotal = response.data.openBillReceivebleTotal;
        this.orderBySalesman = response.data.orderBySalesman;
        // this.accountTransactionsIn   = response.data.accountTransactionsIn;
        this.orderTotalByMonth = response.data.orderTotalByMonth;

        this.$store.commit("hideLoading");
      })
      .catch(error => {
        this.error = error;
        this.$store.commit("hideLoading");
      });
    }
  }
};
</script>

<style>
</style>
